import { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { Loader2 } from 'lucide-react'
import type { CotizacionListItem } from '../types'

interface CotizacionAtendidaModalProps {
  cotizacion: CotizacionListItem | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (data: { atendida: boolean; notas?: string }) => void
  isSubmitting: boolean
}

export function CotizacionAtendidaModal({ cotizacion, open, onOpenChange, onSubmit, isSubmitting }: CotizacionAtendidaModalProps) {
  const [atendida, setAtendida] = useState(false)
  const [notas, setNotas] = useState('')

  useEffect(() => {
    if (open && cotizacion) {
      setAtendida(cotizacion.atendida)
      setNotas('')
    }
  }, [open, cotizacion])

  if (!cotizacion) return null

  const handleSubmit = () => {
    onSubmit({ atendida, notas: notas.trim() || undefined })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Marcar Cotización #{cotizacion.id}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {cotizacion.nombre} — {cotizacion.email}
          </p>

          <div className="flex items-center justify-between">
            <Label htmlFor="atendida">Atendida</Label>
            <Switch
              id="atendida"
              checked={atendida}
              onCheckedChange={setAtendida}
              className="data-[state=checked]:bg-teal-500"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="notas">Notas</Label>
            <Textarea
              id="notas"
              placeholder="Agregar notas de seguimiento..."
              value={notas}
              onChange={(e) => setNotas(e.target.value)}
              rows={3}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button className="bg-teal-800 hover:bg-teal-900 text-white" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Guardar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
